export const chartTypes: { [key: string]: any } = {};
